import React, { useEffect, useState } from 'react';
import { DownloadOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Modal, Upload } from 'antd';
import { ServerAPI } from '../common/ServerAPI';
const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
const AAUpload = ({setSelfAA}) => {
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [defaultList, setDefaultList] = useState([]);
    const [fileList, setFileList] = useState([]);
    const handleCancel = () => setPreviewOpen(false);
    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
    };
    const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);
    const uploadButton = (
        <div className="flex items-center justify-center mt-3 ml-[-100px]">
            <Button className='text-[#0F59F9] border border-[#0F59F9] min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex'><DownloadOutlined className='mr-2 mt-1' /><span style={{margin:"0px!important"}}>Upload Own AA Document</span></Button>
        </div>
    );
    const uploadButtonInline = (
        <div>
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </div>
    );
    const customUploadRequest = async ({ file, onSuccess, onError }) => {
        // Perform your custom file upload logic here
        console.log(file);
        try {
            const response = await ServerAPI.fileUpload(file);
            if (response.resp_code == 200) {
                if (response.data) {
                    const parsedValues = [];
                    parsedValues.push({
                        "name": file.name,
                        "value": response.data
                    });

                    setDefaultList(prevList => [
                        {
                            name: file.name,
                            value: response.data
                        }
                    ]);
                }
                onSuccess();
            }
        } catch (error) {
            // On error, call the onError callback
            onError(error);
        }
    };

    const onRemoveRequest = (file) => {
        setDefaultList((prevDefaultList) => {
            const updatedDefaultList = prevDefaultList.filter((image) => image.name !== file.name);
            return updatedDefaultList;
        });

    }

    useEffect(()=>{
        setSelfAA(defaultList);
    },[defaultList])
    return (
        <>
            <Upload
                customRequest={customUploadRequest}
                maxCount={1}
                style={{ width: "100%" }}
                fileList={fileList}
                onRemove={onRemoveRequest}
                accept=".pdf"
                listType="picture-card"
                onPreview={handlePreview}
                onChange={handleChange}
            >
                {fileList.length == 1 && uploadButtonInline}
                {fileList.length == 0 && uploadButton}
            </Upload>
            <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
                <img
                    alt="example"
                    style={{
                        width: '100%',
                    }}
                    src={previewImage}
                />
            </Modal>
        </>
    );
};
export default AAUpload;